import React, { useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormCheck, FormInput } from "go-form";
import { PaymentMethodApi, PaymentMethodSetting } from "../../../../../../../../../services/Api/Organization/types";
import { getPaymentMethodOnlinePayments } from "../utils";

interface Props {
	form: UseFormReturn<PaymentMethodApi>;
}

const PaymentMethodOnlinePaymentsForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
		getValues,
	} = form;
	const paymentMethods = getPaymentMethodOnlinePayments();

	const findSettingIndexForInput = (inputSetting: PaymentMethodSetting) => {
		const settings = getValues("settings") || [];

		return settings.findIndex((setting) => setting.name === inputSetting);
	};

	const drawPaymentMethods = useMemo(() => {
		return paymentMethods.map((paymentMethod) => {
			const index = findSettingIndexForInput(paymentMethod);

			return (
				<React.Fragment key={paymentMethod}>
					<FormInput
						name={`settings.${index}.name`}
						errors={errors}
						register={register}
						type="hidden"
						value={paymentMethod}
					/>
					<FormCheck
						name={`settings.${index}.value`}
						errors={errors}
						register={register}
						label={t(`enums.payment_method.online_payment.${paymentMethod.replace("_ENABLED", "")}`)}
						type="switch"
					/>
				</React.Fragment>
			);
		});
	}, [paymentMethods]);

	const secretClientIdIndex = findSettingIndexForInput(PaymentMethodSetting.SECRET_TPAY_CLIENT_ID);
	const secretClientSecretIndex = findSettingIndexForInput(PaymentMethodSetting.SECRET_TPAY_CLIENT_SECRET);

	return (
		<fieldset className="form-group no-gutters">
			<h5>{t("modules.payment_method.field.online_payments.title")}</h5>
			<FormInput
				name={`settings.${secretClientIdIndex}.name`}
				errors={errors}
				register={register}
				type="hidden"
				value={PaymentMethodSetting.SECRET_TPAY_CLIENT_ID}
			/>
			<FormInput
				name={`settings.${secretClientIdIndex}.value`}
				errors={errors}
				register={register}
				label="Client ID"
				autoComplete="off"
			/>
			<FormInput
				name={`settings.${secretClientSecretIndex}.name`}
				errors={errors}
				register={register}
				type="hidden"
				value={PaymentMethodSetting.SECRET_TPAY_CLIENT_SECRET}
			/>
			<FormInput
				name={`settings.${secretClientSecretIndex}.value`}
				errors={errors}
				register={register}
				label="Client Secret"
				autoComplete="off"
			/>
			{drawPaymentMethods}
		</fieldset>
	);
};

export default PaymentMethodOnlinePaymentsForm;

// t("enums.payment_method.online_payment.BLIK_OFFLINE");
// t("enums.payment_method.online_payment.BLIK_ONLINE");
// t("enums.payment_method.online_payment.APPLE_PAY");
// t("enums.payment_method.online_payment.GOOGLE_PAY");
// t("enums.payment_method.online_payment.PAYMENT_CARD");
// t("enums.payment_method.online_payment.E_TRANSFER");
